import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { ContentActionsService } from '~commonInfra/contentActions/ContentActions';
import { getDatasourceDetailInfo, openBlankWindow, replaceDatasourceIdWithConnectionIdForMixedContent } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { IDataSourceDetailInfo } from '../../datasource/models/IDataSourceInfo';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { NewWorkbookForDatasourceAction } from '../actions/NewWorkbookForDatasourceAction';

// When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
// Because we are opening a new window in the edit workbook saga which is async, to get around the pop up blocker we need
// to open the window first, then the window.location.href can be set asynchronously afterwards

export function* handleNewWorkbookForDatasourceAction(action: NewWorkbookForDatasourceAction): SagaIterator {
  let newWindow: Window = null;
  try {
    newWindow = openBlankWindow();
    const mutatableContentInfo: IContentInfo[] = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, [action.contentInfo]);
    const datasourceDetailInfo = yield call(getDatasourceDetailInfo, mutatableContentInfo[0].id);
    createNewWorkbookForDatasource(datasourceDetailInfo, newWindow);
  } catch(e) {
    newWindow && newWindow.close();
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function createNewWorkbookForDatasource(datasourceDetailInfo: IDataSourceDetailInfo, newWindow: Window) {
  const contentActionsService = ContentActionsService;
  const sessionManagementService = getSessionManagementServiceInstance();
  newWindow.location.href = contentActionsService.generateNewWorkbookFromDatasourceUrl(datasourceDetailInfo, sessionManagementService.sessionSiteUrlName());
}
